module.exports = __webpack_public_path__ + "static/img/SHOKZ_H5.ba8bec8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner/company-logo/SHOKZ_H5.png
// module id = /kih
// module chunks = 34